export const SET_ALGORITHM = "SET_ALGORITHM";
export const SET_ARRAY = "SET_ARRAY";
export const SET_SIZE = "SET_SIZE";
